import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    'nav.services': 'Services',
    'nav.fleet': 'Flotte',
    'nav.cities': 'Villes',
    'nav.disneyland': 'Disneyland',
    'nav.excursions': 'Excursions',
    'nav.business': 'Entreprises',
    'nav.about': 'À propos',
    'nav.contact': 'Contact',
    'nav.book': 'Réserver',
    'hero.title': 'Le chauffeur privé qui vous ressemble.',
    'hero.subtitle': 'Berlines VIP, vans Mercedes, minibus et autocars jusqu\u2019à 60 places. Service haut de gamme partout en France et en Europe.',
    'hero.cta': 'Demander un devis',
    'book.title': 'Réservez votre trajet',
    'book.oneway': 'Aller simple',
    'book.hourly': 'Mise à disposition',
    'book.from': 'Adresse de prise en charge',
    'book.to': 'Adresse de destination',
    'book.date': 'Date',
    'book.time': 'Heure',
    'book.pax': 'Passagers',
    'book.luggage': 'Bagages',
    'book.vehicle': 'Véhicule',
    'book.submit': 'Voir les tarifs',
    'book.duration': 'Durée',
    'features.title': 'Pourquoi choisir Ha Transport',
    'features.f1.t': 'Ponctualité absolue',
    'features.f1.d': 'Suivi de vol et de train, attente offerte de 60 min sur tous les trajets aéroport.',
    'features.f2.t': 'Chauffeurs professionnels',
    'features.f2.d': 'Costume sombre, formation premium, discrétion garantie.',
    'features.f3.t': 'Flotte récente',
    'features.f3.d': 'Mercedes, BMW, Sprinter, Classe V, autocars grand tourisme.',
    'features.f4.t': 'Tarif tout compris',
    'features.f4.d': 'Pas de surprise. Le prix annoncé est le prix payé.',
    'usecases.title': 'Tout type d\u2019occasion',
    'fleet.title': 'Notre flotte',
    'fleet.subtitle': 'Du transfert individuel au voyage en groupe, choisissez le véhicule adapté à votre besoin.',
    'fleet.pax': 'passagers',
    'fleet.luggage': 'bagages',
    'fleet.book': 'Réserver ce véhicule',
    'cities.title': 'Disponible dans les plus belles villes',
    'cities.subtitle': 'Ha Transport vous accompagne en France comme à l\u2019international.',
    'testimonials.title': 'Ils nous font confiance',
    'cta.title': 'Prêt à voyager autrement ?',
    'cta.sub': 'Devis personnalisé en moins de 2 heures.',
    'cta.btn': 'Demander un devis',
    'contact.title': 'Contactez-nous',
    'contact.subtitle': 'Une demande, un devis, une question ? Notre équipe répond 24/7.',
    'contact.name': 'Nom complet',
    'contact.email': 'E-mail',
    'contact.phone': 'Téléphone',
    'contact.message': 'Message',
    'contact.send': 'Envoyer le message',
    'contact.sent': 'Message envoyé ! Nous vous recontactons rapidement.',
    'about.title': 'Une certaine idée du transport haut de gamme',
    'about.p1': 'Ha Transport est une société française de transport de personnes basée à Roissy-en-France. Depuis nos débuts, nous mettons un point d\u2019honneur à proposer un service à la hauteur des plus grandes attentes : ponctualité, discrétion, élégance.',
    'about.p2': 'Nos chauffeurs sont sélectionnés avec soin et formés aux exigences du service VIP. Notre flotte va de la berline haut de gamme à l\u2019autocar grand tourisme jusqu\u2019à 60 places.',
    'business.title': 'Solutions entreprises',
    'business.subtitle': 'Comptes corporate, facturation centralisée, reporting détaillé.',
    'faq.title': 'Questions fréquentes',
    'footer.tagline': 'Le chauffeur privé haut de gamme, partout en France et en Europe.',
    'footer.contact': 'Contact',
    'footer.services': 'Services',
    'footer.company': 'Société',
    'footer.legal': 'Mentions légales',
    'footer.cgv': 'CGV',
    'footer.privacy': 'Confidentialité',
    'footer.rights': 'Tous droits réservés.'
  },
  en: {
    'nav.services': 'Services',
    'nav.fleet': 'Fleet',
    'nav.cities': 'Cities',
    'nav.disneyland': 'Disneyland',
    'nav.excursions': 'Day trips',
    'nav.business': 'For Business',
    'nav.about': 'About',
    'nav.contact': 'Contact',
    'nav.book': 'Book now',
    'hero.title': 'The private chauffeur, redefined.',
    'hero.subtitle': 'VIP sedans, Mercedes vans, minibuses and coaches up to 60 seats. Premium service across France and Europe.',
    'hero.cta': 'Request a quote',
    'book.title': 'Book your ride',
    'book.oneway': 'One way',
    'book.hourly': 'By the hour',
    'book.from': 'Pickup address',
    'book.to': 'Drop-off address',
    'book.date': 'Date',
    'book.time': 'Time',
    'book.pax': 'Passengers',
    'book.luggage': 'Luggage',
    'book.vehicle': 'Vehicle class',
    'book.submit': 'See prices',
    'book.duration': 'Duration',
    'features.title': 'Why choose Ha Transport',
    'features.f1.t': 'On time, every time',
    'features.f1.d': 'Flight & train tracking, 60 min complimentary wait for airport rides.',
    'features.f2.t': 'Professional chauffeurs',
    'features.f2.d': 'Dark suit, premium training, guaranteed discretion.',
    'features.f3.t': 'Recent fleet',
    'features.f3.d': 'Mercedes, BMW, Sprinter, V-Class, premium coaches.',
    'features.f4.t': 'All-inclusive price',
    'features.f4.d': 'No surprise: the price you see is the price you pay.',
    'usecases.title': 'Every occasion',
    'fleet.title': 'Our fleet',
    'fleet.subtitle': 'From individual transfers to group travel, choose the vehicle that fits.',
    'fleet.pax': 'passengers',
    'fleet.luggage': 'luggage',
    'fleet.book': 'Book this vehicle',
    'cities.title': 'Available in the most beautiful cities',
    'cities.subtitle': 'Ha Transport drives you across France and internationally.',
    'testimonials.title': 'Trusted by',
    'cta.title': 'Ready to travel differently?',
    'cta.sub': 'Personalised quote in under 2 hours.',
    'cta.btn': 'Request a quote',
    'contact.title': 'Contact us',
    'contact.subtitle': 'A request, a quote, a question? Our team is available 24/7.',
    'contact.name': 'Full name',
    'contact.email': 'Email',
    'contact.phone': 'Phone',
    'contact.message': 'Message',
    'contact.send': 'Send message',
    'contact.sent': 'Message sent! We will get back to you shortly.',
    'about.title': 'A vision of premium ground transport',
    'about.p1': 'Ha Transport is a French chauffeur company based in Roissy-en-France. Since day one, we are committed to delivering a service that matches the highest expectations: punctuality, discretion, elegance.',
    'about.p2': 'Our chauffeurs are carefully selected and trained to VIP standards. Our fleet ranges from luxury sedans to 60-seat premium coaches.',
    'business.title': 'Business solutions',
    'business.subtitle': 'Corporate accounts, centralised billing, detailed reporting.',
    'faq.title': 'Frequently asked questions',
    'footer.tagline': 'Premium private chauffeur service, across France and Europe.',
    'footer.contact': 'Contact',
    'footer.services': 'Services',
    'footer.company': 'Company',
    'footer.legal': 'Legal notice',
    'footer.cgv': 'Terms',
    'footer.privacy': 'Privacy',
    'footer.rights': 'All rights reserved.'
  }
};

const I18nContext = createContext({ lang: 'fr', setLang: () => {}, t: (k) => k });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('ha_lang') || 'fr');
  useEffect(() => { localStorage.setItem('ha_lang', lang); }, [lang]);
  const t = (key) => (translations[lang] && translations[lang][key]) || key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
